import CustomHelmet from 'components/customHelmet'
import React from 'react'
import { useSelector } from 'react-redux'
import constants from '../../../utils/constants'

const reverseTransform = item => capitalize(item.replace(/-/g, ' '))
const capitalize = (str, lower = false) =>
    (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["([{])+\S/g, match => match.toUpperCase())

const TitleComp = ({ title }) => {
    var defaultTitle = '7NOW Delivery'
    const currentLocation = window.location
    const path = currentLocation.pathname
    const { customCategoryProducts, categories } = useSelector(
        state => state.products.homePageContent
    )
    let queryParams
    if (path != null) {
        queryParams = decodeURI(path.replace(/%20/g, '-')).split('/')
    }
    const indexCheck = queryParams.indexOf('all')
    if (indexCheck > -1) {
        queryParams.splice(indexCheck, 1)
    }
    let titleDisplayName
    if (queryParams && queryParams.length > 0) {
        for (var i = 0; i < queryParams.length; i++) {
            if (i === 2) {
                if (i === queryParams.length - 1) {
                    titleDisplayName = reverseTransform(queryParams[i])
                        .replace(/%20/g, ' ')
                        .replace(/-/g, ' ')
                        .replace(/%25/g, '%')
                }
            } else if (i === 3) {
                if (i === queryParams.length - 1) {
                    titleDisplayName = reverseTransform(queryParams[i])
                        .replace(/%20/g, ' ')
                        .replace(/-/g, ' ')
                        .replace(/%25/g, '%')
                }
            } else if (i === 4) {
                titleDisplayName = reverseTransform(queryParams[i])
                    .replace(/%20/g, ' ')
                    .replace(/-/g, ' ')
                    .replace(/%25/g, '%')
            } else if (queryParams[i].toLowerCase() === 'faqs') {
                titleDisplayName = 'FAQs'
            }
        }
    }

    const getTitleToShow = () => {
        const categoryCheck = categories?.some(
            p => p.name?.toLowerCase() === titleDisplayName?.toLowerCase()
        )
        const customCategoryCheck = customCategoryProducts?.some(
            p => p.display_name?.toLowerCase() === titleDisplayName?.toLowerCase()
        )
        const indexPositionCheck = queryParams[queryParams.length - 1]
        const dealsCheck = indexPositionCheck === 'deals' && queryParams.includes('home')
        const staticRouteCheck = dealsCheck
            ? false
            : constants?.staticRoutes?.includes(indexPositionCheck)
        if (staticRouteCheck != true) {
            if (!customCategoryCheck && !categoryCheck && dealsCheck != true) {
                return `${titleDisplayName}${' '}${'| 7NOW Delivery'}`
            } else if (categoryCheck && !customCategoryCheck) {
                return `${titleDisplayName}${' '}${'| 7NOW Delivery'}`
            } else if (customCategoryCheck || (dealsCheck && !categoryCheck)) {
                return `${'Shop'}${' '}${titleDisplayName}`
            }
        } else {
            return `${title}` || `${defaultTitle}`
        }
    }

    return <CustomHelmet title={getTitleToShow()} description="7-Eleven Website" />
}

const withTitle = ({ component: ParentComponent, title, isCanonical }) => {
    const Title = props => (
        <>
            <TitleComp title={title} isCanonical={isCanonical} />
            <ParentComponent {...props} />
        </>
    )
    return Title
}

export { withTitle }
